export namespace Globals {

    export class Constants {
        static VERSION_NUMBER = '1.0.27';

        static VERSION_NUMBER_INT =  Number(Constants.VERSION_NUMBER.split(".")[0] + (Constants.VERSION_NUMBER.split(".")[1].padStart(2,'0')) + (Constants.VERSION_NUMBER.split(".")[2].split("_")[0].replace(/\D/g,'').padStart(3,'0')));
    }
}
